<template>
  <v-card v-bind="$attrs">
    <v-card-text>
      <div class="subheading">What Strains?</div>
      <TaxonomySearch solo-inverted chips flat color="orange" rank="strain" :multiple="multipleStrains" v-model="mp.taxonomy"></TaxonomySearch>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text>
      <div class="subheading">Global Values</div>
      <v-layout wrap>
        <v-flex xs12 md4>
          <v-menu
            :close-on-content-click="true"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="mp.inoculation_date"
                label="Inoculation Date"
                required
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="mp.inoculation_date" no-title scrollable>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 md4>
          <ResearcherAutocomplete v-model="mp.researcher" :set-default-as-user="true" hide-details>
          </ResearcherAutocomplete>
        </v-flex>
        <v-flex xs12 md4>
          <OrganizationAutocomplete v-model="mp.organization" :set-default-as-user="true">
          </OrganizationAutocomplete>
        </v-flex>
        <v-flex xs12 md4>
          <CactusAutocomplete
            :multiple="false"
            :api-service="experimentClassAPI"
            add-new-label="Create new experiment class"
            label="Experiment Class"
            item-text="name"
            :add-new-item="true"
            :load-immediate="true"
            v-model="mp.experiment_class">
          </CactusAutocomplete>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field label="Fermentation Volume" suffix="ml" type="number" step="0.1" min="0" v-model="mp.fermentation_volume"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field label="Fermentation Temperature" suffix="°C" type="number" step="0.1" min="0" v-model="mp.fermentation_temperature"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field label="Number of replicons" type="number" step="1" min="1" v-model="replicons"></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text>
      <div class="subheading">Media Panel Breakdown</div>
      <v-layout wrap>
        <v-flex xs12 md6>
          <CactusAutocomplete
            :api-service="cultureMediumAPI"
            chips
            label="Media"
            item-text="name"
            :multiple="true"
            :load-immediate="true"
            required
            v-model="mp.culture_medium">
          </CactusAutocomplete>

        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="submit" color="primary" :disabled="!valid">
        Add
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import TaxonomySearch from '@/components/inputs/autocomplete--taxonomy.vue'
import CactusAutocomplete from '@/components/inputs/autocomplete--agnostic.vue'
import CultureMediumAPI from '@/api/culture-medium.js'
import ExperimentClassAPI from '@/api/experiment-class.js'
import ResearcherAutocomplete from '@/components/inputs/autocomplete--researcher.vue'
import OrganizationAutocomplete from '@/components/inputs/autocomplete--organization.vue'
export default {
  components: {
    TaxonomySearch,
    CactusAutocomplete,
    ResearcherAutocomplete,
    OrganizationAutocomplete
  },
  props: ['value', 'mode', 'multipleStrains'],
  data () {
    return {
      mp: {
        taxonomy: [],
        experiment_class: undefined,
        culture_medium: [],
        organization: undefined, // set a default
        researcher: undefined, // set a default
        inoculation_date: undefined,
        fermentation_volume: undefined,
        fermentation_temperature: undefined
      },
      replicons: 1
    }
  },
  computed: {
    valid () {
      return this.mp.taxonomy.length && this.mp.culture_medium.length && this.mp.organization && this.mp.researcher && this.mp.inoculation_date
    }
  },
  created () {
    this.cultureMediumAPI = CultureMediumAPI
    this.experimentClassAPI = ExperimentClassAPI
  },
  methods: {
    clear () {
      this.mp.taxonomy = []
      this.mp.culture_medium = []
      this.mp.fermentation_volume = undefined
      this.mp.fermentation_temperature = undefined
    },
    submit () {
      const payload = {
        mp: JSON.parse(JSON.stringify(this.mp)),
        replicons: this.replicons
      }
      this.$emit('add', payload)
      this.clear()
    }
  }
}
</script>

<style lang="scss" scoped>
  .subheading {
    margin-bottom: 16px;
  }
</style>
